<template>
  <div class="macro">
    <span class="macro-ic">
      <svg viewBox="0 0 24 24"><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z" /></svg>
    </span>
    <span class="macro-name text-truncate">{{ macro.name }}</span>
    <div class="macros-actions">
      <woot-button
        v-tooltip.left-start="$t('MACROS.EXECUTE.PREVIEW')"
        size="tiny"
        variant="smooth"
        color-scheme="secondary"
        icon="info"
        class="margin-right-smaller btn-primary"
        @click="toggleMacroPreview(macro)"
      />
      <woot-button
        v-tooltip.left-start="$t('MACROS.EXECUTE.BUTTON_TOOLTIP')"
        size="tiny"
        variant="smooth"
        color-scheme="secondary"
        class="btn-primary"
        icon="play-circle"
        :is-loading="isExecuting"
        @click="executeMacro(macro)"
      />
    </div>
    <transition name="menu-slide">
      <macro-preview
        v-if="showPreview"
        v-on-clickaway="closeMacroPreview"
        :macro="macro"
      />
    </transition>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { mixin as clickaway } from 'vue-clickaway';
import MacroPreview from './MacroPreview';
import { CONVERSATION_EVENTS } from '../../../../helper/AnalyticsHelper/events';

export default {
  components: {
    MacroPreview,
  },
  mixins: [alertMixin, clickaway],
  props: {
    macro: {
      type: Object,
      required: true,
    },
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isExecuting: false,
      showPreview: false,
    };
  },
  methods: {
    async executeMacro(macro) {
      try {
        this.isExecuting = true;
        await this.$store.dispatch('macros/execute', {
          macroId: macro.id,
          conversationIds: [this.conversationId],
        });
        this.$track(CONVERSATION_EVENTS.EXECUTED_A_MACRO);
        this.showAlert(this.$t('MACROS.EXECUTE.EXECUTED_SUCCESSFULLY'));
      } catch (error) {
        this.showAlert(this.$t('MACROS.ERROR'));
      } finally {
        this.isExecuting = false;
      }
    },
    toggleMacroPreview() {
      this.showPreview = !this.showPreview;
    },
    closeMacroPreview() {
      this.showPreview = false;
    },
  },
};
</script>

<style scoped lang="scss">
.macro {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-small);
  padding: var(--space-small);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  margin-bottom: var(--space-smaller);
  cursor: pointer;
  transition: border-color 0.15s ease-in-out, background 0.15s ease-in-out;

  &:hover {
    border-color: var(--color-woot);
    background: var(--w-25);
  }

  .macro-ic {
    flex: none;
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: var(--s-50);
    display: grid;
    place-items: center;
    color: #0a7581;

    svg {
      width: 15px;
      height: 15px;
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }

  .macro-name {
    flex: 1;
    min-width: 0;
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium);
    color: var(--s-800);
  }

  .macros-actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
